module.exports = __webpack_public_path__ + "bg-1-tablet-emea.jpg";